<template>
  <a-modal class="formMadal" :visible="basicModal.visible" :title="basicModal.title" :width="basicModal.width" :okText="basicModal.okText?basicModal.okText:'确定'" :cancel="basicModal.cancelText?basicModal.cancelText:'取消'" :okButtonProps="{ props: {disabled: disabledOkBtn} }" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <h4 class="formMadal-content-title" v-if="basicModal.contentTitle">{{basicModal.contentTitle}}</h4>
    <a-form :form="form" :layout="basicModal.formItemLayout.layout?basicModal.formItemLayout.layout:'horizontal'" class="commonForm">
      <a-form-item v-bind="basicModal.formItemLayout" v-for="(item,index) in formLayout" :key="index" :label="item.label">
        <a-input type="text" v-if="item.type==='input'" v-decorator="[item.field,
      { rules: [{ required:item.required, message: '信息不能为空!' }], initialValue:params[item.field]?params[item.field]:undefined},]" placeholder="请输入"></a-input>
        <a-select v-if="item.type==='select'" v-decorator="[
          'gender',
          { rules: [{ required: item.required, message: '信息不能为空!' }],initialValue:params[item.field]?params[item.field]:undefined},
        ]" placeholder="请选择">
          <a-select-option :value="option.id" v-for="(option,index) in item.options" :key="index">
            {{option.name}}
          </a-select-option>
        </a-select>
        <a-textarea type="text" style="height:72px;" v-if="item.type==='textarea'" v-decorator="[item.field,
      { rules: [{ required:item.required, message: '信息不能为空!' }], },]" placeholder="请输入"></a-textarea>
        <a-radio-group v-if="item.type==='radio'" :disabled="item.disabled" v-decorator="[item.field,
        { rules: [{ required: item.required?true:false, message: '信息不能为空!' }],
        initialValue:params[item.field]?params[item.field]:undefined },]">
          <a-radio :value="option.name" :disabled="option.disabled" v-for="(option,index) in item.options" :key="index">{{option.name}}</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  components: {},
  props: {
    params: Object,
    basicModal: Object,
    formLayout: Array,
    disabledOkBtn: {
      default: false,
      type: Boolean,
    },
    confirmLoading: Boolean,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'formModal' }),
    };
  },
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', values);
        }
      });
    },
    handleCancel() {
      this.$emit('cancel');
    },
  },
  created() {},
  watch: {
    basicModal: {
      handler: function(val) {
        if (!val.visible) {
          this.form.resetFields();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
.formMadal {
  &-content-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 22px;
    margin-bottom: 16px;
  }
}
</style>
